import { BusinessFeeNegotiationParty } from '../enums/BusinessFeeNegotiationParty.js';
import { BusinessFeeNegotiationStatus } from '../enums/BusinessFeeNegotiationStatus.js';
/**
 * How many proposals a negotiation may hold. The round that reaches the cap can
 * still be accepted or declined, not countered.
 */
export const BUSINESS_FEE_NEGOTIATION_MAX_ROUNDS = 3;
/** The lowest a business may ask for, as a share of the corridor's default. */
export const BUSINESS_FEE_NEGOTIATION_MIN_FRACTION = 0.6;
/** Why a business withdrew; set when it moved to a sales call. */
export const BUSINESS_FEE_NEGOTIATION_SALES_CALL_NOTE = 'Moved to a sales call';
/** Shown to the business before it sends a request, and on the agreed terms. */
export const BUSINESS_FEE_NEGOTIATION_REVISIT_CLAUSE = 'Custom pricing depends on the monthly volume you expect on each corridor. If those volumes are not met consistently, we may revisit this pricing.';
/** How the admin queue is narrowed: two rollups, and Ongoing split by turn. */
export var BusinessFeeNegotiationFilter;
(function (BusinessFeeNegotiationFilter) {
    BusinessFeeNegotiationFilter["Ongoing"] = "ONGOING";
    BusinessFeeNegotiationFilter["Completed"] = "COMPLETED";
    BusinessFeeNegotiationFilter["AwaitingAdmin"] = "AWAITING_ADMIN";
    BusinessFeeNegotiationFilter["AwaitingBusiness"] = "AWAITING_BUSINESS";
})(BusinessFeeNegotiationFilter || (BusinessFeeNegotiationFilter = {}));
export const NEGOTIATION_STATUSES_BY_FILTER = {
    [BusinessFeeNegotiationFilter.Ongoing]: [
        BusinessFeeNegotiationStatus.PendingAdmin,
        BusinessFeeNegotiationStatus.PendingBusiness,
    ],
    [BusinessFeeNegotiationFilter.Completed]: [
        BusinessFeeNegotiationStatus.Accepted,
        BusinessFeeNegotiationStatus.Rejected,
        BusinessFeeNegotiationStatus.Cancelled,
    ],
    [BusinessFeeNegotiationFilter.AwaitingAdmin]: [
        BusinessFeeNegotiationStatus.PendingAdmin,
    ],
    [BusinessFeeNegotiationFilter.AwaitingBusiness]: [
        BusinessFeeNegotiationStatus.PendingBusiness,
    ],
};
export const BUSINESS_FEE_NEGOTIATION_SETTLED_STATUSES = [
    BusinessFeeNegotiationStatus.Accepted,
    BusinessFeeNegotiationStatus.Rejected,
    BusinessFeeNegotiationStatus.Cancelled,
];
/** A settled outcome as one phrase. Withdrawn is never called declined. */
export const getNegotiationOutcomeLabel = (status) => {
    switch (status) {
        case BusinessFeeNegotiationStatus.Accepted:
            return 'Pricing agreed';
        case BusinessFeeNegotiationStatus.Rejected:
            return 'Declined';
        case BusinessFeeNegotiationStatus.Cancelled:
            return 'Withdrawn by the merchant';
        default:
            return undefined;
    }
};
/** A settled outcome as one word, for a table cell. */
export const getNegotiationOutcomeShortLabel = (status) => {
    switch (status) {
        case BusinessFeeNegotiationStatus.Accepted:
            return 'Accepted';
        case BusinessFeeNegotiationStatus.Rejected:
            return 'Declined';
        case BusinessFeeNegotiationStatus.Cancelled:
            return 'Withdrawn';
        default:
            return undefined;
    }
};
/** Everything a screen needs to describe a negotiation, derived in one place. */
export const getNegotiationDisplay = (negotiation) => {
    const waitingOn = {
        [BusinessFeeNegotiationStatus.PendingAdmin]: BusinessFeeNegotiationParty.Afriex,
        [BusinessFeeNegotiationStatus.PendingBusiness]: BusinessFeeNegotiationParty.Business,
    };
    return {
        isOpen: Boolean(waitingOn[negotiation.status]),
        waitingOn: waitingOn[negotiation.status],
        outcomeLabel: getNegotiationOutcomeLabel(negotiation.status),
        outcomeShortLabel: getNegotiationOutcomeShortLabel(negotiation.status),
        roundLabel: `Round ${negotiation.rounds?.length ?? 0} of ${BUSINESS_FEE_NEGOTIATION_MAX_ROUNDS}`,
    };
};
//# sourceMappingURL=BusinessFeeNegotiation.js.map